var map = {
	"./project/brunei-desktop.jpg": "a059",
	"./project/brunei.jpg": "3958",
	"./project/cambodia-desktop.jpg": "4c46",
	"./project/cambodia.jpg": "138e",
	"./project/china-desktop.jpg": "8bb9",
	"./project/china.jpg": "1201",
	"./project/germany-desktop.jpg": "40fe",
	"./project/germany.jpg": "b17f",
	"./project/icon-ar.svg": "3406",
	"./project/india-desktop.jpg": "94e4",
	"./project/india.jpg": "ce7d",
	"./project/indonesia-desktop.jpg": "f4b2",
	"./project/indonesia-detail-1.jpg": "e7a5",
	"./project/indonesia.jpg": "b686",
	"./project/japan-desktop.jpg": "1a57",
	"./project/japan.jpg": "3b29",
	"./project/jordan-desktop.jpg": "a858",
	"./project/jordan.jpg": "cc64",
	"./project/laos-desktop.jpg": "d9b6",
	"./project/laos.jpg": "1b48",
	"./project/lion-desktop.jpg": "6a5b",
	"./project/lion.jpg": "73c5",
	"./project/malaysia-desktop.jpg": "088a",
	"./project/malaysia.jpg": "dad6",
	"./project/menu/brunei-thumb.jpg": "a9ba",
	"./project/menu/cambodia-thumb.jpg": "b1bc",
	"./project/menu/china-thumb.jpg": "7bdf",
	"./project/menu/germany-thumb.jpg": "9bd8",
	"./project/menu/india-thumb.jpg": "7ee8",
	"./project/menu/indonesia-thumb.jpg": "3494",
	"./project/menu/japan-thumb.jpg": "a23e",
	"./project/menu/jordan-thumb.jpg": "3f89",
	"./project/menu/laos-thumb.jpg": "bb18",
	"./project/menu/malaysia-thumb.jpg": "0238",
	"./project/menu/myanmar-thumb.jpg": "6fde",
	"./project/menu/netherlands-thumb.jpg": "2544",
	"./project/menu/philippines-thumb.jpg": "5de7",
	"./project/menu/russia-thumb.jpg": "b8e9",
	"./project/menu/south-africa-thumb.jpg": "e844",
	"./project/menu/thailand-thumb.jpg": "d130",
	"./project/menu/united-arab-emirates-thumb.jpg": "9bdd",
	"./project/menu/united-kingdom-thumb.jpg": "e457",
	"./project/menu/united-states-thumb.jpg": "ca67",
	"./project/menu/vietnam-thumb.jpg": "826d",
	"./project/myanmar-desktop.jpg": "9f64",
	"./project/myanmar.jpg": "c65c",
	"./project/netherlands-desktop.jpg": "13c7",
	"./project/netherlands.jpg": "a0fb",
	"./project/philippines-desktop.jpg": "6e61",
	"./project/philippines.jpg": "a925",
	"./project/russia-desktop.jpg": "a02a",
	"./project/russia.jpg": "14a2",
	"./project/south-africa-desktop.jpg": "e01a",
	"./project/south-africa.jpg": "3362",
	"./project/thailand-desktop.jpg": "b475",
	"./project/thailand.jpg": "5b0d",
	"./project/uae-desktop.jpg": "9c19",
	"./project/uae.jpg": "4d02",
	"./project/united-kingdom-desktop.jpg": "e2fe",
	"./project/united-kingdom.jpg": "532c",
	"./project/united-states-desktop.jpg": "f9ad",
	"./project/united-states.jpg": "40e0",
	"./project/vietnamese-porcelain-desktop.jpg": "a2dd",
	"./project/vietnamese-porcelain.jpg": "8018",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";